const styles = () => ({
  newSegmentButtonIcon: {
    marginRight: 6,
  },

  newSegmentButton: {
    marginTop: 'auto',
    marginBottom: 24,
    fontSize: 14,

    '&::before': {
      backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #F1FCF8 100%)',
    },

    '&:hover::before': {
      backgroundColor: '#fff',
    },
  },
});

export default styles;
